<template>
  <span class="dateTimeStr">{{ utc0DateStr }}</span>
</template>

<script>
export default {
  name: "DateTime",
  data() {
    return {
      utc0DateStr: "",
    };
  },
  mounted() {
    this.startInterval();
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    startInterval() {
      this.interval = setInterval(() => {
        const now = new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, "0"); // 月份从 0 开始
        const day = String(now.getUTCDate()).padStart(2, "0");
        const hours = String(now.getUTCHours()).padStart(2, "0");
        const minutes = String(now.getUTCMinutes()).padStart(2, "0");
        const seconds = String(now.getUTCSeconds()).padStart(2, "0");

        this.utc0DateStr = `${year}/${month}/${day} ${hours}:${minutes}:${seconds} (UTC+0:00)`;
      }, 1000); // 每秒更新一次
    },
    clearInterval() {
      clearInterval(this.interval);
    },
  },
};
</script>
<style lang="less" scoped>
.dateTimeStr {
  line-height: 20px;
  color: #0b205d;
  font-size: 14px;
  font-weight: 500;
}
</style>
